export interface Metadata {
  createdAt?: number;
  createdBy?: string;
  updatedAt?: number;
  updatedBy?: string;
}

export enum UserRole {
  TEAM_MEMBER = "TEAM_MEMBER",
  SCHOOL = "SCHOOL",
  ADMIN = "ADMIN",
  EDITOR = "EDITOR",
  PRINCIPAL = "PRINCIPAL",
  TEACHER = "TEACHER",
  STUDENT = "STUDENT",
}

export interface ApiErrorResponse {
  error: string;
  status: number;
}
export interface ApiSuccessResponse {
  message: string;
  data: string;
  status: number;
}
